const CONFIG = {
  //hubUrl: "https://localhost:44321/audioHub",
  hubUrl: "https://api.cueroom.online/audioHub",
  //baseURL: "https://localhost:44321/api",
  baseURL: "https://api.cueroom.online/api",
};

export default CONFIG;